import { createContext } from "react"

const OnlineStatusContext = createContext(true)

export { OnlineStatusContext }
